import StarIcon from "@heroicons/react/20/solid/StarIcon";

import { useGetProduct } from "queries/legacy/product-queries";
import { SSR_CONFIGURATION_ERROR } from "utils/error-utils";
import { CANVAS_FALLBACK_CONTENT } from "utils/fallback-content";
import { useInterpolate } from "utils/prismic-utils";

import styles from "./Upsell.module.scss";

type UpsellProps = {
  amount: string;
};

/**
 * Badge showing additional cost of option or 'FREE'.
 */
export default function Upsell({ amount }: UpsellProps) {
  const { data: product } = useGetProduct();
  const interpolate = useInterpolate();

  if (!product) {
    throw SSR_CONFIGURATION_ERROR;
  }

  return (
    <span className={styles.upsell}>
      <StarIcon className={styles.star} />
      {/* Strip non-numeric chars to check for 000 (e.g. S$0.00, £0.00GBP) */}
      {amount.replace(/\D/g, "") === "000"
        ? interpolate(
            product.content.canvas.free_upsell_label ||
              CANVAS_FALLBACK_CONTENT.free_upsell_label
          )
        : amount}
    </span>
  );
}
